export const environment = {
  production: true,
  international: false,
  h5_shop_url: 'https://shop-h5.myhostex.com',
  web_url: 'https://www.myhostex.com',
  version: '2.10.0'
};
